import { utils, writeFileXLSX } from 'xlsx';

export type Column = {
  label: string;
  field: string;
  dataFormat?: (value: any) => string;
};

export const useExcelDownload = () => {
  function getNestedValue(object: any, keyString: string): any {
    const key = keyString.replace(/\[(\w+)]/g, '.$1').replace(/^\./, '');
    const a = key.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
      const k = a[i];
      if (k in object) {
        // eslint-disable-next-line no-param-reassign
        object = object[k];
      } else {
        return undefined;
      }
    }
    return object;
  }

  const exportExcel = (
    columns: Column[],
    data: any[],
    fileName: string = 'export',
    sheetName: string = 'Sheet1',
    fileType: 'xlsx' | 'xls' = 'xlsx',
  ) => {
    const createXLSLFormatObj: string[][] = [];
    const newXlsHeader: string[] = [];
    if (columns.length === 0) {
      throw new Error('Add columns!');
    }
    if (data.length === 0) {
      throw new Error('Add data!');
    }
    columns.forEach((column: Column) => {
      newXlsHeader.push(column.label);
    });

    createXLSLFormatObj.push(newXlsHeader);
    data.forEach((value) => {
      const innerRowData: string[] = [];
      columns.forEach((val) => {
        let fieldValue = value[val.field];
        if (val.field.split('.').length > 1) {
          fieldValue = getNestedValue(value, val.field);
        }
        if (val.dataFormat && typeof val.dataFormat === 'function') {
          innerRowData.push(val.dataFormat(fieldValue));
        } else {
          innerRowData.push(fieldValue);
        }
      });
      createXLSLFormatObj.push(innerRowData);
    });

    const fullFileName = `${fileName}.${fileType}`;
    const wsName = sheetName;

    const wb = utils.book_new();
    const ws = utils.aoa_to_sheet(createXLSLFormatObj);
    utils.book_append_sheet(wb, ws, wsName);
    writeFileXLSX(wb, fullFileName);
  };

  return {
    exportExcel,
  };
};
